import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useSystemStore } from '@/stores/modules/system'
import { useUserStore } from '@/stores/modules/user'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export { useSystemStore, useUserStore }

export default pinia
